export type RpcErrorPayload = {
  error?: {
    code?: string;
    message?: string;
    data?: unknown;
  };
};

export type RpcEnvelope<Return> = RpcErrorPayload & {
  data?: Return;
};

function retryAfterSeconds(response: Response) {
  const value = Number(response.headers.get("retry-after"));
  return Number.isFinite(value) && value > 0 ? Math.ceil(value) : 60;
}

function fallbackEnvelope<Return>(response: Response): RpcEnvelope<Return> {
  if (response.status === 429) {
    const seconds = retryAfterSeconds(response);
    return {
      error: {
        code: "RATE_LIMITED",
        message: `Sono state inviate troppe richieste. Attendi ${seconds} secondi e riprova.`,
        data: { code: "RATE_LIMITED", retryAfterSeconds: seconds },
      },
    };
  }
  return {
    error: {
      code: response.ok ? "INVALID_SERVER_RESPONSE" : "HTTP_ERROR",
      message: response.ok
        ? "Il server ha restituito una risposta non valida."
        : "Il server non ha potuto completare la richiesta.",
      data: { status: response.status },
    },
  };
}

export async function readRpcEnvelope<Return>(
  response: Response,
): Promise<RpcEnvelope<Return>> {
  const text = await response.text();
  if (!text.trim()) return fallbackEnvelope(response);
  try {
    const payload = JSON.parse(text) as unknown;
    if (payload && typeof payload === "object" && !Array.isArray(payload)) {
      return payload as RpcEnvelope<Return>;
    }
  } catch {
    // The fallback below converts proxy and rate-limit text into a stable RPC
    // envelope instead of leaking a JSON parser exception into the interface.
  }
  return fallbackEnvelope(response);
}
